import assetInventory from './assetInventory'
import assetInventoryCategory from './assetInventoryCategory'
import auth from './auth'
import billingEmails from './billingEmails'
import churnMeetings from './churnMeetings'
import churnReasons from './churnReasons'
import churns from './churns'
import collaboratorProfiles from './collaboratorProfiles'
import companies from './companies'
import companySizes from './companySizes'
import companySuppliers from './companySuppliers'
import coupons from './coupons'
import dataCollectedOptions from './dataCollectedOptions'
import dataCollecteds from './dataCollecteds'
import dataLifeCycles from './dataLifeCycles'
import dataProcesses from './dataProcesses'
import dataTreatmentAgents from './dataTreatmentAgents'
import dataTreatments from './dataTreatments'
import demoPartner from './demoPartner'
import departments from './departments'
import documents from './documents'
import documentTemplates from './documentTemplates'
import economicActivities from './economicActivities'
import fantasyDpos from './fantasyDpos'
import faqsDocumentations from './faqsDocumentations'
import faqsDocumentationsCategories from './faqsDocumentationsCategories'
import fiancial from './financial'
import groups from './groups'
import integrationPartnerPlans from './integrationPartnerPlans'
import integrationPartners from './integrationPartners'
import integrationPartnerWebhooks from './integrationPartnerWebhooks'
import internationalTransfer from './internationalTransfers'
import lastUpdates from './lastUpdates'
import legalFrameworks from './legalFrameworks'
import logs from './logs'
import moodleLotus from './moodleLotus'
import nonComplianceReports from './nonComplianceReports'
import observerInvite from './observerInvite'
import outsourcedDpo from './outsourcedDpo'
import paymentContract from './paymentContract'
import paymentContractServices from './paymentContractServices'
import paymentLink from './paymentLink'
import paymentOrders from './paymentOrders'
import paymentServiceTemplates from './paymentServiceTemplates'
import plans from './plans'
import preRegistrations from './preRegistrations'
import privacyPolicies from './privacyPolicies'
import questionControls from './questionControls'
import questionnaires from './questionnaires'
import questions from './questions'
import segments from './segments'
import sellers from './sellers'
import sharedSoftwares from './sharedSoftwares'
import ssoCorporateGroupCompanies from './ssoCorporateGroupCompanies'
import ssoCorporateGroupOrganizations from './ssoCorporateGroupOrganizations'
import ssoCorporateGroups from './ssoCorporateGroups'
import ssoCorporateGroupUsers from './ssoCorporateGroupUsers'
import subgroups from './subgroups'
import technicalFaqs from './technicalFaqs'
import transferCommisions from './transferCommisions'
import user from './users'
import userCollaborators from './userCollaborators'
import userCompanies from './userCompanies'

const dponet = {
  assetInventory,
  assetInventoryCategory,
  auth,
  billingEmails,
  churnMeetings,
  churnReasons,
  churns,
  collaboratorProfiles,
  companies,
  companySizes,
  companySuppliers,
  coupons,
  dataCollectedOptions,
  dataCollecteds,
  dataLifeCycles,
  dataProcesses,
  dataTreatmentAgents,
  dataTreatments,
  demoPartner,
  departments,
  documents,
  documentTemplates,
  economicActivities,
  fantasyDpos,
  faqsDocumentations,
  faqsDocumentationsCategories,
  fiancial,
  groups,
  integrationPartnerPlans,
  integrationPartners,
  integrationPartnerWebhooks,
  internationalTransfer,
  lastUpdates,
  legalFrameworks,
  logs,
  moodleLotus,
  nonComplianceReports,
  observerInvite,
  outsourcedDpo,
  paymentContract,
  paymentContractServices,
  paymentLink,
  paymentOrders,
  paymentServiceTemplates,
  plans,
  preRegistrations,
  privacyPolicies,
  questionControls,
  questionnaires,
  questions,
  segments,
  sellers,
  sharedSoftwares,
  ssoCorporateGroupCompanies,
  ssoCorporateGroupOrganizations,
  ssoCorporateGroups,
  ssoCorporateGroupUsers,
  subgroups,
  technicalFaqs,
  transferCommisions,
  user,
  userCollaborators,
  userCompanies,
}

export default dponet
